import { MissingCostsEnum } from 'api';
import { Alert } from 'ui';

type Props = {
  missingCosts?: MissingCostsEnum[];
};

const getDisplayedMissingCost = (missingCost: MissingCostsEnum) => {
  switch (missingCost) {
    case MissingCostsEnum.DESTINATION_INTERMODAL_COST:
      return 'destination intermodal cost';
    case MissingCostsEnum.DESTINATION_TERMINAL_HANDLING_CHARGE:
      return 'destination terminal handling charge';
    case MissingCostsEnum.LOCAL_DESTINATION_COST:
      return 'local destination cost';
    case MissingCostsEnum.LOCAL_ORIGIN_COST:
      return 'local origin cost';
    case MissingCostsEnum.OCEAN_FREIGHT_COST:
      return 'ocean freight cost';
    case MissingCostsEnum.ORIGIN_DOC_FEE:
      return 'origin doc fee';
    case MissingCostsEnum.ORIGIN_INTERMODAL_COST:
      return 'origin intermodal cost';
    case MissingCostsEnum.ORIGIN_TERMINAL_HANDLING_CHARGE:
      return 'origin terminal handling charge';
  }
};

export const MissingCostsAlert = ({ missingCosts }: Props) => {
  if ((missingCosts?.length || 0) > 0) {
    return (
      <Alert severity="warning">
        The price estimate might be incorrect because of missing components:{' '}
        {missingCosts?.map((missingCost) => getDisplayedMissingCost(missingCost)).join(', ')}. Please, reach out to
        Michael for a better quote.
      </Alert>
    );
  }
  return null;
};
